import React from "react";
import {connect} from 'react-redux'
import {find} from 'lodash'
import {Link} from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import AccountCircle from "@material-ui/icons/AccountCircle";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

//Material Ui components
import GridContainer from "components/Grid/GridContainer.jsx";
//import FormControl from "@material-ui/core/FormControl";
//import InputLabel from '@material-ui/core/InputLabel';
//import Select from '@material-ui/core/Select';
//import MenuItem from '@material-ui/core/MenuItem';

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import {
  danger,
} from 'actions/notification'

import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";

import "assets/scss/custom/react-select.css";
import Select from 'react-select/lib/Async';

// Actions
import {
  clientFilter,
  clientsFetch,
  clientRemove,
  setClientViewFilter,
  clientFetchExternal,
  setClientProfile,
  setClientIb
} from 'actions/clients'

import {
  profilesFetch,
  profileFilter,
} from 'actions/profiles'

import {
  setAccountClient
} from 'actions/accounts'

import {
  profilesFetchIbs,
  profilesFetchAllFilter,
} from 'actions/profiles'

const link = {
  cursor: 'pointer'
}

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    textAlign: 'left',
  }),
   /*control: () => ({
    // none of react-select's styles are passed to <Control />
    width: 250,
    borderBottom: '1px solid silver',
  }),*/
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

class List extends React.Component {
  selected=[]
  state = {
    selected: [],
    profileId: 0,
    remoteFilters:{
      name: '',
      email: '',
      externalId: ''
    }
  }

  constructor(props){
        super(props)
        this.state.value=props.value
    }


  componentDidMount(){
    
    this.props.profileFilter({size: 1000000,sort:{name: 'asc'}})
    this.loadProfiles();

    this.props.filter({size: 10})
    this.fetchclients()
    //this.fetchAllclients();
    //alert(this.state.profileId);
    if (this.state.profileId!==0) {
      //this.props.setClientProfile({profileId: this.state.profileId})
      this.props.profilesFetchAll().then(e=>{
        
      let value=this.props.selectAll?{profileId:0}:e.content[0].profileId;
      let label=this.props.selectAll?{profileName:''}:e.content[0].name;
        
        this.setState({
          ...this.state,
          value:value.profileId,
          profileId:value.profileId

        });

        this.setState({...this.state, profileNameSelected: {value, label},ibNameSelected: {value:'', label:'Ibs'}})
        this.props.setClientProfile({profileId: value, profileName: label})

        //this.props.filter({filter: {profileId: e.content[0].profileId}});
        //this.props.fetch().then(e=>this.filter())
      
      });
    } else {
      //const {accounts: {selectedClientId, selectedClientName, selectedIbId, selectedIbName, selectedProfileId, selectedProfileName}} = this.props
      //this.setState({...this.state, clientNameSelected: {value: selectedClientId, label:selectedClientName}, ibNameSelected: {value: selectedIbId, label:selectedIbName}, profileNameSelected: {value: selectedProfileId, label:selectedProfileName}})
      
    }

  }

  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id))
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1)
      select = this.state.selected.filter((e) => e !== id)
    else
      select = this.state.selected.concat(id)
    let client = find(this.props.clients.list, (c) => c.clientId === select[0])
    if (!client) {
      this.setState({
        ...this.state,
        selected: select
      })
    } else {
      this.setState({
        ...this.state,
        selected: select,
        selectedIb: client.ibId,
        selectedProfile: client.profileId
      })
    }
  }
  confirmDelete() {
      let {selectedIbId, selectedProfileId} = this.props.clients
      if(this.selected.length===0){
        this.props.fetch(selectedIbId, selectedProfileId)
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete clients (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0], selectedIbId, selectedProfileId)
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        }).catch((e) => {
          this.props.danger(e+'',4)
          this.setState({...this.state,alert:false})
        })
  }
  //on choose click delete
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} clients \n( ${
          this.state.selected.map(id=>this.props.clients.list.find(e=>e.clientId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    let {selectedIbId, selectedProfileId} = this.props.clients
    this.setState({...this.state,selected:[]})

    this.props.filter({
      ...this.props.clients.pageable,
      ...filter,
      page: filter.size
        ? 0
        : filter.page !== undefined ? filter.page : this.props.clients.pageable.page
    })
    this.props.fetch(selectedIbId, selectedProfileId)

  }
  handleChange(e) {
    let propertyName = e.target.name
    let data = {
      filterName: propertyName,
      value: e.target.value
    }
    this.props.setClientViewFilter(data)
    this.fetchclients(data)
  }

  fetchclients(data) {
    let {selectedIbId, selectedProfileId} = this.props.clients
    if (data) {
      if(data.filterName === 'selectedIbId') {
        selectedIbId = data.value
      } else {
        selectedProfileId = data.value
      }
    }

    this.props.filter({
      ...this.props.clients.pageable,
      page: 0
    })
    this.props.fetch(selectedIbId, selectedProfileId)
  }

  /*fetchAllclients(){
    this.props.filter({
      ...this.props.clients.pageable,
      page: 0
    })
    this.props.fetch()
  }*/

  loadProfiles = () => {
    return this.props.profilesFetch()
        .then((r) => {
          const allOption = {value: '', label: 'All IBs'}
          const options = r.content.map((i) => { return {value: i.ibId, label: `${i.firstName} ${i.lastName} (${i.ibId})`} })
          return [allOption].concat(options)
        }  
    )
  }

  filterSelect() {
    //const { classes, profiles ,ibs} = this.props
    //let {selectedIbId, selectedProfileId} = this.props.clients

    
    return <GridContainer >
      
      {/*<GridItem xs={12} sm={4}>
        {
        <FormControl
          fullWidth
          className={classes.selectFormControl}
        >
          <InputLabel htmlFor="selectedProfileId" className={classes.selectLabel} >
            Profile
          </InputLabel>
          <Select
            value={selectedProfileId ? selectedProfileId.toString() : 0}
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            inputProps={{
              onChange: this.handleChange.bind(this),
              id: "selectedProfileId",
              name: "selectedProfileId"
            }}>
            <MenuItem
              key={0}
              classes={{
                root: classes.selectMenuItem
              }}
              value={0}>
              {'All'}
            </MenuItem>
            {profiles.list
              .map((e) => (
                <MenuItem
                  key={e.profileId}
                  classes={{
                    root: classes.selectMenuItem
                  }}
                  value={e.profileId.toString()}>
                  {e.name}
                </MenuItem>
              ))}
          </Select>

        </FormControl>
        }
      </GridItem>
      <GridItem xs={12} sm={4}>
      {
        <FormControl
          fullWidth
          className={classes.selectFormControl}
        >
          <InputLabel htmlFor="selectedIbId" className={classes.selectLabel} >
            Ib
          </InputLabel>
          <Select
            value={selectedIbId ? selectedIbId.toString() : 0}
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            inputProps={{
                onChange:this.handleChange.bind(this),
                id: "selectedIbId",
                name: "selectedIbId"
            }}>

            <MenuItem
              key={0}
              classes={{
                root: classes.selectMenuItem
              }}
              value={0}>
              {'All'}
            </MenuItem>

            {ibs
              .map((e) => (
                <MenuItem
                  key={e.ibId}
                  classes={{
                    root: classes.selectMenuItem
                  }}
                  value={e.ibId.toString()}>
                  {e.name+' '+e.lastName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      }
      </GridItem>*/}

    </GridContainer>
  }
  redirectToTarget = (clientId, name) => {
    this.props.setAccountClient({clientId, name})
    this.props.history.push(`/administration/accounts`)
  }
  sortTable(columnKey){
    const {clients} = this.props;
    this.filter({sort:{[columnKey]:clients.pageable.sort[columnKey]==='desc'?'asc':'desc'}})
    //this.filter({sort:{[e]:clients.pageable.sort[e]==='desc'?'asc':'desc'}})
  }
  fetchRemoteFilter(value, key){
    let {selectedIbId, selectedProfileId} = this.props.clients
    
    this.setState({
      ...this.state,
      remoteFilters: {
        ...this.state.remoteFilters,
        [key]: value
      }
    })

    this.props.fetch(selectedIbId, selectedProfileId, value, false)
  }

  /*
  * onChange select options
  */
  selectProfileChange = ({value, label}) =>{

    this.setState({...this.state, profileNameSelected: {value, label},ibNameSelected: {value:'', label:'Ibs'}})
    this.props.setClientProfile({profileId: value, profileName: label})
    this.props.filter({size: 10,filter: {profileId: value}});
    this.props.fetch(null,value)

  }

  /*
  * filter by name text
  */
  selectProfileHandleInputChange = (newValue) => {

    this.setState({...this.state, profileName: newValue})
    //this.setState({...this.state,profileId: newValue.profileId});
    return newValue;

  }
  
  /*
  * load select options
  */
  selectProfileLoadOptions = (inputValue, callback) => {

    return this.props.profilesFetchAll(inputValue,false)
        .then((r) => {
          const allOption = {value: '', label: 'All Profiles'}
          const options = r.content.map((i) => { return {value: i.profileId, label: `${i.name} (${i.profileId})`} })
          return [allOption].concat(options)
        }  
    );
  }

  /*
  * onChange select options
  */
  selectIbChange = ({value, label}) =>{
    
    let { selectedProfileId} = this.props.clients;

    this.setState({...this.state, ibNameSelected: {value, label}})
    this.props.setClientIb({ibId: value, ibName: label})
    this.props.filter({size: 10,filter: {profileId: selectedProfileId,ibId: value}});
    this.props.fetch(value, selectedProfileId);

  }

  /*
  * filter by name text
  */
  selectIbHandleInputChange = (newValue) => {
    this.setState({...this.state, clientName: newValue})
    return newValue;
  }

  /*
  * load select options
  */
  selectIbLoadOptions = (inputValue, callback) => {
    let { selectedProfileId} = this.props.clients;
    
    if (selectedProfileId) {
      
      return this.props.profilesFetchIbs(selectedProfileId,false)
          .then((r) => {
            const allOption = {value: '', label: 'All Ibs'}
            const options = r.map((i) => {return {value: i.ib.ibId, label: `${i.ib.firstName} ${i.ib.lastName} (${i.ib.ibId})`}})
            return [allOption].concat(options)
          }  
      );

    } else {

      return {};
    
    }

  }

  
  render() {
    const {match, clients, permissions} = this.props;
    const {selectedIbId, selectedProfileId} = this.props.clients
    const {selected, selectedIb, selectedProfile} = this.state
    
    const filterColumns = [
      {
        name: 'name',
        filterChangeAction: (value, key) => this.fetchRemoteFilter(value, key),
        value: this.state.remoteFilters.name
      },
      {
        name: 'email',
        filterChangeAction: (value, key) => this.fetchRemoteFilter(value, key),
        value: this.state.remoteFilters.email
      },
      {
        name: 'externalId',
        filterChangeAction: (value, key) => this.fetchRemoteFilter(value, key),
        value: this.state.remoteFilters.externalId
      },
    ]

    return (
      <Card>
        {this.state.alert}
        {
        (!clients.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={clients.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={clients.pageable.totalPages>1?{
            pages:clients.pageable.totalPages,
            current:clients.pageable.page+1,
          }:false}
          title={this.filterSelect()}
          dark={selected.length>0}
          icon={<AccountCircle/>}
          actions={{
          add: (selected.length===0)
            ? <Link to={`${match.path}/add/`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && permissions.includes('CLIENTS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}/ib/${selectedIbId || selectedIb}/profile/${selectedProfileId || selectedProfile}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : ''
        }}/>:''}

        <CardBody>

          {/* If is fetching not display table*/}
          {(clients.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <div style={{width: '100%',margin: '0 auto',display: 'block'}}>
                <div>
                  <div style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectProfileLoadOptions}
                      defaultOptions
                      onInputChange={(e) => this.selectProfileHandleInputChange(e)}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectProfileChange(e)}
                      value={this.state.profileNameSelected || ''}
                      placeholder="Search Profiles..."
                    />
                  </div>
                  <div className="" style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectIbLoadOptions}
                      defaultOptions
                      onInputChange={this.selectIbHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectIbChange(e)}
                      value={this.state.ibNameSelected || ''}
                      placeholder="Search Ibs..."
                    />
                  </div>
                </div>
              <Table
                tableHeaderColor="primary"
                striped
                sort={clients.pageable.sort}
                onSort={(e) => this.sortTable(e) }
                filterColumns={filterColumns}
                tableHead={{
                    checkbox:<Checkbox props = {{
                      onClick:()=>this.select(clients.list.map(e=>e.clientId)),
                      checked:this.state.selected.length===clients.list.length}
                    }/>,
                    clientId:"#",
                    name:"Name",
                    email:"Email",
                    description:"Phone",
                    externalId:"External ID",
                  }}
                tableData={clients.list.map((e,i) => [
                    <Checkbox props = {{
                      onClick:()=>this.select(e.clientId),
                      checked:this.state.selected.indexOf(e.clientId)>-1
                    }}/>,
                    e.clientId,
                    <a style={link} onClick={() => this.redirectToTarget(e.clientId, e.name)}>
                      {e.name}
                    </a>,
                    <a style={link} onClick={() => this.redirectToTarget(e.clientId, e.name)}>
                      {e.email}
                    </a>,
                    e.phoneNumber,
                    e.externalId
                  ]
                  )}
              /></div>
            )}
        </CardBody>
       {
         clients.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={clients.pageable.totalPages>1?{
              pages:clients.pageable.totalPages,
              current:clients.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.clients,
  ibs: state.ibs.list,
  profiles: state.profiles,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(clientFilter(filter)),
  fetch: (ibid, profileid, clientName, loading) => dispatch(clientsFetch(ibid, profileid, clientName, loading)),
  remove: (clinetid, ibid, profileid) => dispatch(clientRemove(clinetid, ibid, profileid)),
  setClientViewFilter: (data) => dispatch(setClientViewFilter(data)),
  clientFetchExternal:(externalClientId, loading) => dispatch(clientFetchExternal(externalClientId, loading)),
  profilesFetch: () => dispatch(profilesFetch()),
  profileFilter: (filter) => dispatch(profileFilter(filter)),
  setAccountClient: (data) => dispatch(setAccountClient(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  profilesFetchAll: (profileName, loading) => dispatch(profilesFetchAllFilter(profileName, loading)),
  profilesFetchIbs: (profileId, loading) => dispatch(profilesFetchIbs(profileId, loading)),
  setClientProfile: (data) => dispatch(setClientProfile(data)),
  setClientIb: (data) => dispatch(setClientIb(data)),
})
export default withStyles({...buttonsStyle, ...selectStyles})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Clients/List.jsx